const ThemeProvider = ({ children }) => {
  return <div className={'font-urbanist'}>{children}</div>;
};
export default ThemeProvider;
